<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <!-- <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Application Form Details</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
                <v-col cols="12" sm="3">
                   
                </v-col>
            </v-row> 
       </v-card>-->

            <v-card class="box" v-if="application_forms_list!=''">
                <center> <span v-if="pay_fee_flag" class="flash">Kindly pay Rs. {{form_fees}} to complete the form submission process.</span> </center>
                <v-data-table :headers="headers" :items="application_forms_list">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Application Form Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                   
                    <!-- <template v-slot:[`item.fees_paid`]="{ item }">
                        <span v-if="!item.fees_paid">
                            <span v-if="item.applicationstatus=='Submitted'">
                                <v-btn v-if="tenant=='zeal'" color="primary darken-1" @click="payFormFeesBillDesk(item)" :loading="pay_btn_load">Pay</v-btn>
                                <span v-else-if="tenant=='sbpps' || 'vvp'">
                                    <span v-if="item.quota == 'RTE'">
                                                    --
                                    </span>
                                    <span v-if="item.std_quota_flag">
                                        <form :action="url" @submit="payFormFeesPaytm()" name="paytmform" method="POST">
                                            <input type="hidden" :value="item.orgid" name="orgid" />
                                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                                            <input type="hidden" :value="item.uid" name="uid" />
                                            <input type="hidden" :value="item.amount" name="amount" />
                                            <input type="hidden" :value="item.hash_val" name="hash_val" />
                                            <input type="hidden" :value="item.id" name="id" />
                                            <v-btn type="submit" color="primary darken-1" :loading="pay_btn_load">Pay</v-btn>
                                        </form>
                                    </span>
                                    <span v-else>
                                        No seats available for this standard 
                                    </span>
                                </span>
                                <v-btn v-else color="primary darken-1" @click="alert('Contact School')" :loading="pay_btn_load">Pay</v-btn>
                            </span>
                             <span v-else>--</span>  
                        </span>
                        <span v-else><v-btn color="primary darken-1" @click="viewReceipt(item)" :loading="pay_btn_load">Receipt</v-btn></span>
                    </template> -->
                    <template v-slot:[`item.fees_paid`]="{ item }">
    <span v-if="!item.fees_paid">
        <span v-if="item.applicationstatus == 'Submitted'">
            <v-btn v-if="tenant == 'zeal'" color="primary darken-1" @click="payFormFeesBillDesk(item)" :loading="pay_btn_load">
                Pay
            </v-btn>
            <span v-else-if="tenant == 'sbpps' && isBillDesk">
                <span v-if="item.quota == 'RTE'">
                    --
                </span>
                <span v-else-if="item.std_quota_flag">
                    <v-btn color="primary" @click="payBillDesk(item)" :loading="pay_btn_load"> Pay(BillDesk) </v-btn>
                </span>
                <span v-else>
                    No seats available for this standard
                </span>
            </span>
            <span v-else-if="tenant == 'sbpps' || tenant == 'vvp'">
                <span v-if="item.quota == 'RTE'">
                    --
                </span>
                <span v-else-if="item.std_quota_flag">
                    <form :action="url" @submit="payFormFeesPaytm()" name="paytmform" method="POST">
                        <input type="hidden" :value="item.orgid" name="orgid" />
                        <input type="hidden" :value="item.tenantid" name="tenantid" />
                        <input type="hidden" :value="item.uid" name="uid" />
                        <input type="hidden" :value="item.amount" name="amount" />
                        <input type="hidden" :value="item.hash_val" name="hash_val" />
                        <input type="hidden" :value="item.id" name="id" />
                        <v-btn type="submit" color="primary darken-1" :loading="pay_btn_load">Pay</v-btn>
                    </form>
                </span>
                <span v-else>
                    No seats available for this standard
                </span>
            </span>
            <span v-else-if="tenant == 'desschool'">
                <span v-if="item.quota == 'RTE'">
                    --
                </span>
                <span v-else>
                        <v-btn color="primary" @click="payCCAvenue(item)" :loading="pay_btn_load"> Pay </v-btn>
                </span>
            </span>
            <v-btn v-else color="primary darken-1" @click="alert('Contact School')" :loading="pay_btn_load">Pay</v-btn>
        </span>
        <span v-else>--</span>
    </span>
    <span v-else>
        <v-btn color="primary darken-1" @click="viewReceipt(item)" :loading="pay_btn_load">Receipt</v-btn>
    </span>
</template>

                </v-data-table>
                <br>
                <v-row dense justify="center"><strong>If status is still 'Initiated' after submitting the form, please refresh the page  
                    <v-btn class="button" @click="onLoad">
                        <v-icon color="warning">mdi-refresh</v-icon> Refresh</v-btn></strong></v-row>
                </v-card>
            <!-- <v-card class="box" v-if="defaultValues!=null && if_receipt_generated">
          <v-col cols="12" sm="12" md="12" class="mr-5 pr-5"> <div  v-html="defaultValues"></div> </v-col>
        </v-card> -->
            <form id="ccavenueForm" :action="ccUrl" method="POST">
                <input type="hidden" name="encRequest" :value="encRequest" />
                <input type="hidden" name="access_code" :value="accessCode" />
            </form>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            pay_btn_load: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            tenant: null,
            title: "",
            description: "",
            application_forms_list: [],
            if_receipt_generated:null,
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Form No", value: "display_admission_form_no" },
                { text: "Application Date", value: "application_date" },
                { text: "Admission Year", value: "admissionyear" },
                { text: "Fees(In Rs)", value: "amount" },
                { text: "Status", value: "applicationstatus" },
                { text: "Quota", value: "quota" },
                { text: "Pay", value: "fees_paid" },
            ],
            //Bill desk
            checksumurl: null,
            returnURL: null,
            defaultValues:null,
            pay_fee_flag:null,form_fees:"",
            encRequest: null,
            accessCode: null,
            ccUrl: null,
            billdeskMsg: null,
            isBillDesk: false,
            //
        }),
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/payFormFeesPaytm";

            this.ccInitiateUrl = process.env.VUE_APP_API_URL + "/paymentGatewayCCAvenue/payFormFeesCCAvenue"

            this.tenant = localStorage.getItem("EPS-tenant");
        },
        methods: {
            viewReceipt(item) {
                this.$store.commit("setform_fees_trans_id", item.transaction_id);
                this.$router.push({ name: "form-fees-receipt" });
            },


            payCCAvenue(item) {

                this.pay_btn_load = true

                let formData = new FormData();
                formData.append("orgid", item.orgid);
                formData.append("tenantid", item.tenantid);
                formData.append("uid", item.uid);
                formData.append("amount", item.amount);
                formData.append("hash_val", item.hash_val);
                formData.append("id", item.id);
                formData.append("purpose", "FORM Fees");

                axios.post(this.ccInitiateUrl, formData)
                    .then(res => {
                        if(res.data.statusCode == "200"){
                            this.encRequest = res.data.encRequest
                            this.accessCode = res.data.accessCode
                            this.ccUrl = res.data.ccUrl

                            this.$nextTick(() => {
                                document.getElementById("ccavenueForm").submit()
                            })
                        }else{
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong")
                        }

                    })
                    .catch(() => {
                        this.showSnackbar("#b71c1c", "Payment initiation failed")
                    })
                    .finally(() => {
                        this.pay_btn_load = false
                    })
            },

            payBillDesk(item) {

                this.pay_btn_load = true

                let formData = new FormData();
                formData.append("orgid", item.orgid);
                formData.append("tenantid", item.tenantid);
                formData.append("uid", item.uid);
                formData.append("amount", item.amount);
                formData.append("hash_val", item.hash_val);
                formData.append("id", item.id);

                axios.post("/paymentGatewayBillDesk/payFormFeesBillDesk",  formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }

                    })
                    .catch(() => {
                        this.showSnackbar("#b71c1c", "Payment initiation failed")
                    })
                    .finally(() => {
                        this.pay_btn_load = false
                    })
            },

            startBillDesk() {
                if (!this.billdeskMsg) {
                    this.showSnackbar("red", "Payment data missing")
                    return
                }

                bdPayment.initialize({
                    msg: this.billdeskMsg,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2
                    }
                });
            },

            //    BillDesk start -------------------------------------------------------------------
            payFormFeesBillDesk(item) {
                const data = {
                    application_id: item.id,
                };
                this.pay_btn_load = true;
                axios
                    .post("/Parent/payFormFeesBillDesk", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            //this.application_forms_list=res.data.applicationFormDetails
                            this.checksumurl = res.data.checksumurl;
                            this.returnURL = res.data.returnURL;
                            this.payFeesBillDesk();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //this.overlay = false;
                        this.pay_btn_load = false;
                    });
            },
            payFormFeesPaytm() {
                var formData = new FormData();
                this.pg_loader = false;

                // this.pay_btn_load = true
                //  axios
                // .post("/Parent/payFormFeesPaytm", item)
                // .then((res) => {
                //  if (res.data.flag == "NO") {
                //     this.showSnackbar("#b71c1c", res.data.smsg);
                // }
                // //    else {
                // //     this.showSnackbar("#b71c1c", "Something went wrong!!!");
                // //     sessionStorage.setItem("error-trace", res.data.error_trace);
                // //   }
                //   this.pay_btn_load = false
                // })
                // .catch((error) => {
                //   this.showSnackbar("#b71c1c", "Something Went Wrong");
                //   this.pay_btn_load = false
                // })
                // .finally(() => {
                //     this.pay_btn_load = false
                // });
            },
            payFeesBillDesk() {
                bdPayment.initialize({
                    msg: this.checksumurl,
                    callbackUrl: this.returnURL,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2,
                    },
                });
            },
            //    BillDesk end -------------------------------------------------------------------

            onLoad() {
                this.overlay = true;
                axios
                    .post("/Parent/getApplicationFormDetails")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.application_forms_list = res.data.applicationFormDetails;
                            this.defaultValues = res.data.defaultValues
                            this.pay_fee_flag = res.data.pay_fee_flag
                            this.form_fees = res.data.form_fees
                            this.if_receipt_generated = res.data.if_receipt_generated
                            this.isBillDesk = res.data.isBillDesk
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //this.overlay = false;
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
.flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
